import styled, { css } from 'styled-components';
import { th, variants } from 'style/theme';
import { sizes } from 'style';
import TextInput from '../TextInput';

export const Card = styled.div`
  ${variants('variant', {
    light: css`
      background-color: #def3f3; /* 80% lighter turquoise, only used here */
    `,
    dark: css`
      background-color: ${th('colors.indigoLigth4')};
    `,
    blue: css`
      background-color: rgba(189, 219, 255, 0.3);
    `,
    turquoise: css`
      background-color: ${th('colors.iceCold')};
    `
  })}

  width: 100%;
  border-radius: 8px;
  padding: 12px 14px 0 14px;
`;

export const Line1 = styled(TextInput)`
  margin-bottom: 7px;
`;

export const Row = styled.div`
  @media ${sizes.tabletLandscape} {
    display: flex;
    gap: 20px;
  }
`;
